import React from 'react'
import { useTranslation } from 'react-i18next'
import { ResultsLayout } from 'components/layout/ResultsLayout'
import { useGetApplicationsQuery } from 'hooks/queries/Customers/useGetApplicationsQuery'
import { AddCustomerCta } from '../AddCustomer/AddCustomerCta'
import { ApplicationItems } from './ApplicationItems'

export const CustomersListV2 = () => {
  const { t } = useTranslation()

  const { data, isFetching, isError, refetch } = useGetApplicationsQuery()

  const applicationsData = data || []

  const AddButton = <AddCustomerCta refetchCustomers={refetch} />

  return (
    <ResultsLayout
      testId="customers-v2-results"
      isLoading={isFetching}
      isError={isError}
      hasResults={!!applicationsData?.length}
      hasSearchAndFilter={false}
      showSearchAndFilter={false}
      searchAndFilter={{}}
      resetSearchAndFilters={() => {}}
      refetchResults={refetch}
      header={{
        description: t('customers.descriptionV2'),
        renderRightSection: AddButton,
      }}
      emptyState={{
        title: t('embeddedCustomers.emptyStatus.headline'),
        description: t('embeddedCustomers.emptyStatus.descriptionAddDetails'),
        PrimaryButton: AddButton,
      }}
    >
      <ApplicationItems applications={applicationsData} />
    </ResultsLayout>
  )
}
